import { getClient } from '@/lib/restClient';
import { MenuManagementExecutionService } from '@/services/Execution/MenuManagementExecutionService';

export type MenuManagementExecutionCreateParams = {
  associate_brand_id: number;
  scheduled_date: string | null;
};

export const useMenuManagementCreateExecution = async (
  params: MenuManagementExecutionCreateParams
): Promise<void> => {
  const menuManagementExecutionService = new MenuManagementExecutionService(
    getClient()
  );
  return menuManagementExecutionService.create(params);
};
